import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grow, Grid, Badge, Box, Tabs, Tab, IconButton, Typography, Paper } from "@mui/material";
import PropTypes from "prop-types";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WorkHistory, Work } from "@mui/icons-material";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import { DataGrid, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { getSparePartListColumns } from "../../common";
import { getTechnicianList } from "../../store/actions/userActions";
import { getPoolList, getSparePartUsageList, getSparePartUsagePlannedList, getListStockCodesAndMaterialDescriptions } from "../../store/actions/SparePartActions";
import { downloadUnplannedExcelFile, downloadPlannedExcelFile } from "../../store/actions/SparePartExcelActions";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
            <Box>{children}</Box>
        </Typography>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
var materialDescs = [];
var materialDescsName = [];
const ss = sessionStorage;
export default function SparePartList() {
    const [value, setValue] = useState(0);
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [poolData, setPoolData] = useState([]);
    const [selectedMaterialDescId, setSelectedMaterialDescId] = useState(0);
    const [selectedMaterialName, setSelectedMaterialName] = useState("");
    const [poolIds, setPoolIds] = useState([]);
    const [usageStartDate, setUsageStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 1)));
    const [usageEndDate, setUsageEndDate] = useState(new Date());
    const [userData, setUserData] = useState([]);
    const [userIds, setUserIds] = useState([]);
    const [userName, setUserName] = useState("");
    const [excelFilterState, setExcelFilterState] = useState({});

    let history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation("translation");

    useEffect(() => {
        getBreakdownSparePartList();
    }, []);

    const getBreakdownSparePartList = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        const data = {
            areaId: ss.getItem("spl_selectedAreaCode") ?? 0,
            machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            poolIds: poolIds || [],
            assigneeIds: userIds || [],
            sparePartUsageDate: {
                startDate: usageStartDate,
                endDate: usageEndDate,
            },
            sparePartId: selectedMaterialDescId,
        };
        let payload = {
            data: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize,
        };
        dispatch(getSparePartUsageList(payload));
        setExcelFilterState(data);
    };

    const getPlannedSparePartList = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        const data = {
            areaId: ss.getItem("spl_selectedAreaCode") ?? 0,
            machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            poolIds: poolIds || [],
            assigneeIds: userIds || [],
            sparePartUsageDate: {
                startDate: usageStartDate,
                endDate: usageEndDate,
            },
            sparePartId: selectedMaterialDescId,
        };
        let payload = {
            data: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize,
        };
        dispatch(getSparePartUsagePlannedList(payload));
        setExcelFilterState(data);
    };

    const {
        user: { technicianList },
    } = useSelector((user) => user);

    useEffect(() => {
        if (technicianList) {
            setUserData(technicianList);
        }
    }, [technicianList]);

    const { poolList, sparePartUsageList, sparePartUsagePlannedList, materialDescriptions } = useSelector(({ SparePart }) => SparePart);

    useEffect(() => {
        if (poolList) {
            setPoolData(poolList);
        }
    }, [poolList]);

    useEffect(() => {
        if (materialDescriptions?.resultObject) {
            materialDescs = Object.values(materialDescriptions.resultObject).map((item) => ({
                id: item.id,
                name: item.materialCode_MaterialDescription,
            }));
            materialDescsName = materialDescs.map((option) => option.name);
        }
    }, [materialDescriptions]);

    useEffect(() => {
        if (sparePartUsageList?.resultObject?.content) {
            setRows(sparePartUsageList.resultObject.content);
            setRowCount(sparePartUsageList.resultObject.totalCount);
        }
    }, [sparePartUsageList]);

    useEffect(() => {
        if (sparePartUsagePlannedList?.resultObject?.content) {
            setRows(sparePartUsagePlannedList.resultObject.content);
            setRowCount(sparePartUsagePlannedList.resultObject.totalCount);
        }
    }, [sparePartUsagePlannedList]);

    useEffect(() => {
        HandleClearFilter();
    }, [value]);

    const handleChangeTasks = (event, newValue) => {
        setValue(newValue);
        setCurrentPage(0);
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event) => {
        setCurrentPage(_event);
        if (value === 0) {
            getBreakdownSparePartList(_event, rowsPerPage);
        }
        if (value === 1) {
            getPlannedSparePartList(_event, rowsPerPage);
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event);
        setCurrentPage(0);
        if (value === 0) {
            getBreakdownSparePartList(currentPage, event);
        }
        if (value === 1) {
            getPlannedSparePartList(currentPage, event);
        }
    };

    const NavigateToDetails = (id) => {
        if (value === 0) {
            history.push("breakdowndetail?id=" + id);
        } else if (value === 1) {
            history.push("/planned-maintenance-detail?id=" + id);
        }
    };

    // Set pool
    const HandlePool = (poolName) => {
        let ids = [];
        poolName.map((item) => ids.push(item.id));
        setPoolIds(ids);
    };

    // Set start date
    const HandleSparePartUsageStartDate = (date) => {
        if (date == null) {
            setUsageStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1)));
        } else {
            setUsageStartDate(moment(date).format("YYYY-MM-DD"));
        }
    };

    // Set end date
    const HandleSparePartUsageEndDate = (date) => {
        if (date == null) {
            setUsageEndDate(new Date());
        } else {
            setUsageEndDate(moment(date).format("YYYY-MM-DD"));
        }
    };

    //set user ınfo
    const HandleUser = (userName) => {
        const userInfo = userData.filter((item) => item.userName == userName);
        let userId = null;

        if (userInfo[0] != undefined) {
            // Filter if user exist
            userId = userInfo[0].id;
        }
        if (userName == null) {
            ss.removeItem("spl_userName");
            ss.removeItem("spl_user");
        } else {
            ss.setItem("spl_userName", userName);
            ss.setItem("spl_user", userId);
        }
        if (userId != null) {
            setUserIds([userId]);
            setUserName(userName);
        } else {
            setUserIds([]);
            setUserName("");
        }
    };

    //set selected material
    const HandleMaterialDescription = (selectedMaterialDesc) => {
        const material = materialDescs.filter((item) => item.name == selectedMaterialDesc);
        let materialId = null;

        if (material[0] != undefined) {
            materialId = material[0].id;
        }
        if (materialId != null) {
            setSelectedMaterialDescId(materialId);
            setSelectedMaterialName(selectedMaterialDesc);
        } else {
            setSelectedMaterialDescId(0);
            setSelectedMaterialName("");
        }
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        if (open) {
            dispatch(getTechnicianList());
            dispatch(getPoolList());
            dispatch(getListStockCodesAndMaterialDescriptions());
        }
        setIsFilterDrawerOpen(open);
    };

    const columnVisibilityModelData = JSON.parse(localStorage.getItem("columnVisibilityModel")) || {};
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(columnVisibilityModelData);
    const customToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarDensitySelector />
                <GridToolbarColumnsButton name="column" />
                {/* <GridToolbarFilterButton /> */}
            </GridToolbarContainer>
        );
    };

    const handleChangeVisibility = (newModel) => {
        setColumnVisibilityModel(newModel);
        localStorage.setItem("columnVisibilityModel", JSON.stringify(newModel));
    };

    const HandleApplyFilter = () => {
        if (value === 0) {
            getBreakdownSparePartList();
        }
        if (value === 1) {
            getPlannedSparePartList();
        }
        setIsFilterDrawerOpen(false);
    };

    const HandleClearFilter = () => {
        setPoolIds([]);
        setUserIds([]);
        setUserName("");
        setSelectedMaterialDescId(0);
        setSelectedMaterialName("");
        setUsageStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1)));
        setUsageEndDate(new Date());
        HandleClearMachineStates();
        setIsFilterDrawerOpen(false);
        if (value === 0) {
            const data = {
                areaId: 0,
                machineId: 0,
                poolIds: [],
                assigneeIds: [],
                sparePartUsageDate: {
                    startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
                    endDate: new Date(),
                },
                sparePartId: 0,
            };
            let payload = {
                data: data,
                currentPage: 1,
                pageSize: rowsPerPage,
            };
            dispatch(getSparePartUsageList(payload));
        }
        if (value === 1) {
            const data = {
                areaId: 0,
                machineId: 0,
                poolIds: [],
                assigneeIds: [],
                sparePartUsageDate: {
                    startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
                    endDate: new Date(),
                },
                sparePartId: 0,
            };
            let payload = {
                data: data,
                currentPage: 1,
                pageSize: rowsPerPage,
            };
            dispatch(getSparePartUsagePlannedList(payload));
        }
    };

    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "spl",
            selectedAreaCode: isCleared ? null : ss.getItem("spl_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("spl_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("spl_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("spl_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("spl_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("spl_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("spl_selectedAreaCode");
        ss.removeItem("spl_selectedAreaName");
        ss.removeItem("spl_selectedMainEquipmentCode");
        ss.removeItem("spl_selectedMainEquipmentName");
        ss.removeItem("spl_selectedSubEquipmentCode");
        ss.removeItem("spl_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const filter = () => {
        return (
            <DetailFilter
                HandleSparePartUsageStartDate={HandleSparePartUsageStartDate}
                usageStartDate={usageStartDate}
                HandleSparePartUsageEndDate={HandleSparePartUsageEndDate}
                usageEndDate={usageEndDate}
                maxDate={new Date()}
                minDate={"2020-01-01"}
                HandlePool={HandlePool}
                poolIds={poolIds}
                poolData={poolData}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
                HandleUser={HandleUser}
                userData={userData}
                userName={userName}
                HandleMaterialDescription={HandleMaterialDescription}
                selectedMaterialDescName={selectedMaterialName}
                materialDescData={materialDescs}
                materialDescsName={materialDescsName}
            />
        );
    };

    return (
        <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
            <FilterDrawer
                open={isFilterDrawerOpen}
                onOpen={toggleDrawer(true)}
                onClose={toggleDrawer(false)}
                HandleClearFilter={HandleClearFilter}
                HandleApplyFilter={HandleApplyFilter}
                downloadExcel={() =>
                    value === 0
                        ? dispatch(
                              downloadUnplannedExcelFile({
                                  ...excelFilterState,
                              })
                          )
                        : dispatch(
                              downloadPlannedExcelFile({
                                  ...excelFilterState,
                              })
                          )
                }
                detailFilter={filter()}
            />
            <FilterButton onClick={() => toggleDrawer(true)} />

            <Grid item style={{ marginTop: 10 }}>
                <Tabs value={value} onChange={handleChangeTasks} variant="fullWidth" centered>
                    <Tab
                        style={{ display: "flex" }}
                        icon={
                            <IconButton id="ap_BreakdownMaintenanceList" aria-label="cart">
                                <Badge color="warning" size="small">
                                    <Work style={{ marginRight: 15, color: "#ffe082" }} />
                                </Badge>
                            </IconButton>
                        }
                        label={t("BreakdownMaintenanceList")}
                    />
                    <Tab
                        style={{ display: "flex" }}
                        icon={
                            <IconButton id="ap_PlannedList" aria-label="cart">
                                <Badge color="success" size="small">
                                    <WorkHistory style={{ marginRight: 15, color: "#b9f6ca" }} />
                                </Badge>
                            </IconButton>
                        }
                        label={t("PlannedList")}
                    />
                </Tabs>
            </Grid>
            <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                <Grid item style={{ marginTop: 10, width: "95%" }}>
                    <Paper elevation={3}>
                        {rows.length > 0 ? (
                            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                                <div style={{ width: "100%", textAlign: "center" }}>
                                    <DataGrid
                                        autoHeight={true}
                                        rows={rows}
                                        columns={getSparePartListColumns()}
                                        pageSize={rowsPerPage}
                                        onPageSizeChange={handleChangeRowsPerPage}
                                        onPageChange={handleChangePage}
                                        rowsPerPageOptions={[5, 10, 20, 50]}
                                        rowCount={rowCount} //total count
                                        page={currentPage}
                                        onRowClick={(param) => {
                                            NavigateToDetails(param.row.taskId);
                                        }}
                                        paginationMode="server"
                                        disableColumnFilter
                                        disableColumnMenu
                                        components={{
                                            Toolbar: customToolbar,
                                        }}
                                        filterMode="server"
                                        columnVisibilityModel={columnVisibilityModel}
                                        onColumnVisibilityModelChange={(newModel) => handleChangeVisibility(newModel)}
                                        //onSortModelChange={(sortModel) => handleSort(sortModel)}
                                        getRowId={(rows) => rows.taskId + rows.sparePartMaterialCode}
                                        sx={{
                                            boxShadow: 5,
                                            "& .MuiDataGrid-row:hover": {
                                                color: "primary.main",
                                            },
                                            "& .MuiDataGrid-columnSeparator": {
                                                display: "none",
                                            },
                                            "& .default-row-color": {
                                                backgroundColor: "#f6f9f5",
                                                color: "#1a3e72",
                                                fontWeight: "600",
                                            },
                                            "& .planned-row-color": {
                                                backgroundColor: "#EAF2E8",
                                                color: "#1a3e72",
                                                fontWeight: "600",
                                            },
                                            "& .unPlanned-row-color": {
                                                backgroundColor: "rgb(198,218,214)",
                                                color: "#1a3e72",
                                                fontWeight: "600",
                                            },
                                        }}
                                        localeText={{
                                            toolbarColumns: t("Columns"),
                                            columnsPanelTextFieldLabel: t("ColumnsPanelTextFieldLabel"),
                                            columnsPanelTextFieldPlaceholder: t("ColumnsPanelTextFieldPlaceholder"),
                                            columnsPanelShowAllButton: t("ColumnsPanelShowAllButton"),
                                            columnsPanelHideAllButton: t("ColumnsPanelHideAllButton"),
                                            toolbarDensity: t("Density"),
                                            toolbarDensityCompact: t("DensityCompact"),
                                            toolbarDensityStandard: t("DensityStandard"),
                                            toolbarDensityComfortable: t("DensityComfortable"),
                                        }}
                                    />
                                </div>
                            </Grow>
                        ) : null}
                    </Paper>
                </Grid>
            </Grid>
            <LoadingBackdrop id="bd_lbd" />
        </Grid>
    );
}
